import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, until } from '@helpers/media';
import CtaLinkStyles from '@stories/Components/CtaLink/CtaLink.styles';
import styled from 'styled-components';
const Container = styled.a `
  display: block;

  &:focus,
  &:hover {
    ${CtaLinkStyles.Container} {
      text-decoration-color: ${brand.black};
    }
  }

  @media ${until(Device.TabletLarge)} {
    text-align: center;

    ${CtaLinkStyles.Container} {
      font-size: 14px;
      letter-spacing: -0.03em;
    }
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(365, 250)};

  margin-bottom: ${fluid(10, 12)};
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const NavigationSimpleMenuStyles = {
    Container,
    ImageWrapper,
    Image,
};
export default NavigationSimpleMenuStyles;
